import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Problem from "../components/landing/Problem";
import Solution from "../components/landing/Solution";
import HowItWorks from "../components/landing/HowItWorks";
import Product from "../components/landing/Product";
import Compartments from "../components/landing/Compartments";
import AppMockup from "../components/landing/AppMockup";
import Professions from "../components/landing/Professions";
import Vehicle from "../components/landing/Vehicle";
import Fleet from "../components/landing/Fleet";
import Ecosystem from "../components/landing/Ecosystem";
import PriceStudy from "../components/landing/PriceStudy";
import Questionnaire from "../components/landing/Questionnaire";
import Notify from "../components/landing/Notify";
import Faq from "../components/landing/Faq";
import Footer from "../components/landing/Footer";
import Seo from "../components/Seo";
import { initScrollTracking, scrollToId, track } from "../lib/api";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    track("page_view", { page: "landing" });
    const cleanup = initScrollTracking();
    if (window.location.hash) {
      setTimeout(() => scrollToId(window.location.hash.slice(1)), 500);
    }
    return cleanup;
  }, []);

  return (
    <div className="bg-[#0C0D0E] min-h-screen" data-testid="landing-page">
      <Seo title="STOCKBOX 8 — Boîte de rangement connectée pour professionnels" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Solution />
        <HowItWorks />
        <Product />
        <Compartments />
        <AppMockup />
        <Professions />
        <Vehicle />
        <Fleet />
        <Ecosystem />
        <PriceStudy />
        <Questionnaire />
        <Faq />
        <Notify />
      </main>
      <Footer />
    </div>
  );
}
